export default __webpack_public_path__ + "static/media/regulatory--trucks-on-right--g1.5ad11e57.png";